<template>
  <div class="add-product" style="background-color: var(--vtm-surface); padding: 15px">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      :span-method="objectSpanMethod"
      height="80vh"
    >
      <el-table-column :width="100" prop="date" :label="$t('system.moduleName')" align="center">
        <template #default="scope">
          <span v-if="scope.row.type === 1">{{ $t("system.order") }}</span>
          <span v-if="scope.row.type === 2">{{ $t("system.machine") }}</span>
          <span v-if="scope.row.type === 3">{{ $t("system.account") }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txyw') + ':'" align="center">
        <template #default="scope">
          {{ $t("system." + scope.row.wname) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txdx')" align="center">
        <template #default="scope">
          <el-checkbox v-model="scope.row.self" true-label="1" false-label="0">{{ $t("system.acUser") }}</el-checkbox>
          <el-checkbox v-model="scope.row.repair" true-label="1" false-label="0">{{ $t("system.yyUser") }}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txLock')" align="center" width="150px">
        <template #default="scope">
          <template v-if="scope.$index == 0 || scope.$index == 1 || scope.$index == 4 || scope.$index == 5">
            <el-switch
              v-model="scope.row.enabled"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </template>
          <template v-else>
            <el-switch v-model="scope.row.enabled" active-value="1" inactive-value="0"> </el-switch>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.sendType')" align="center">
        <template #default="scope">
          <el-checkbox v-model="scope.row.phone" true-label="1" false-label="0">{{ $t("system.sms") }}</el-checkbox>
          <el-checkbox
            v-model="scope.row.email"
            true-label="1"
            false-label="0"
            @change="emailChangeHandler($event, scope.$index, scope.row)"
          >
            {{
              scope.$index == 0 || scope.$index == 1 || scope.$index == 4 || scope.$index == 5
                ? $t("system.email")
                : $t("system.email") 
            }}
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('system.txnrck')" align="center">
        <template #default="scope">
          <el-button type="text" @click="handlerLookTips(1, scope.row.phoneText)">{{ $t("system.sms") }}</el-button>
          <el-button type="text" @click="handlerLookTips(2, scope.row.emailText)">{{ $t("system.email") }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('system.cz')" fixed="right" align="center" width="250">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit-outline" @click="handlerExitOne(scope.row)">{{
            $t("system.bjyjtx")
          }}</el-button>
          <el-button type="text" icon="el-icon-message" @click="handlerEditSms(scope.row)">{{
            $t("system.bjdxtx")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-row :gutter="20" style="margin: 10px 0px">
      <el-col style="line-height: 2; color: #666">{{ $t("system.xxtxTip") }}</el-col>
      <el-col style="line-height: 2; color: #666">
        {{ $t("system.dxsf") }}<span style="color: #ff2a6c">${{ smsprice }}</span
        >{{ $t("system.yt") }}</el-col
      >
      <el-col style="line-height: 2; color: #666">
        {{ $t("system.yjsf") }}<span style="color: #ff2a6c">$0.01</span>{{ $t("system.yt") }}</el-col
      >
    </el-row> -->
    <el-row :gutter="20" style="margin: 10px 0px">
      <el-button @click="reset"> {{ $t("system.reset") }}</el-button>
      <el-button :loading="loading" type="primary" @click="handlerSave">{{ $t("system.save") }}</el-button>
    </el-row>
    <!-- 查看提醒内容 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="lookTips.title"
      :visible.sync="lookTips.dialogVisible"
      width="30%"
    >
      <span v-html="lookTips.content"></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookTips.dialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="lookTips.dialogVisible = false">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 邮件编辑 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('system.yjbj')"
      :visible.sync="exitDialogVisible"
      width="60%"
    >
      <el-form ref="form" :model="nowRow" label-width="110px">
        <el-form-item :label="$t('system.txyw')">{{ $t("system." + nowRow.wname) }}</el-form-item>

        <el-form-item :label="$t('system.yjbt')" required>
          <el-input style="max-width: 240px" v-model="nowRow.emailTitle" :placeholder="$t('system.pyjbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.yjnr')" required>
          <el-row style="margin-top: 20px;">
            <el-col :span="16">
              <el-input 
                type="textarea" 
                :rows="8" 
                v-model="nowRow.emailText" 
                :placeholder="$t('system.pyjnr')"
                maxlength="500"
                show-word-limit
              />
            </el-col>
            <el-col :span="8">
              <div style="background-color: var(--vtm-well); margin-left: 4%; padding: 4%">
                <div style="color: #aaa">{{ $t("system.djTip") }}</div>
                <ul>
                  <template v-if="nowRow.type == 1">
                    <li v-for="(item, index) in ddkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="nowRow.type == 2">
                    <li v-for="(item, index) in jqkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="nowRow.type == 3">
                    <li v-for="(item, index) in zhkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                </ul>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exitDialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveEmailContent">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 短信编辑 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('system.dxbj')"
      :visible.sync="smsDialogVisible"
      width="60%"
    >
      <el-form ref="smsForm" :model="nowRow" label-width="110px">
        <el-form-item :label="$t('system.txyw')">{{ $t("system." + nowRow.wname) }}</el-form-item>

        <el-form-item :label="$t('system.dxbt')" required>
          <el-input style="max-width: 240px" v-model="nowRow.phoneTitle" :placeholder="$t('system.pdxbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.dxnr')" required>
          <el-row style="margin-top: 20px;">
            <el-col :span="16">
              <el-input 
                type="textarea" 
                :rows="8" 
                v-model="nowRow.phoneText" 
                :placeholder="$t('system.pdxnr')"
                maxlength="160"
                show-word-limit
              />
            </el-col>
            <el-col :span="8">
              <div style="background-color: var(--vtm-well); margin-left: 4%; padding: 4%">
                <div style="color: #aaa">{{ $t("system.djTip") }}</div>
                <ul>
                  <template v-if="nowRow.type == 1">
                    <li v-for="(item, index) in ddkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="nowRow.type == 2">
                    <li v-for="(item, index) in jqkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="nowRow.type == 3">
                    <li v-for="(item, index) in zhkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                </ul>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="smsDialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveSmsContent">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 跳转钱包提示 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('common.tip')"
      :visible.sync="dialogToWallet"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @close="handlerCloseWallet"
    >
      <span class="el-icon-info" style="color: #eaa74d; font-size: 20px; margin-right: 4px"></span>
      <span>{{ $t("system.yebz") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handlerCloseWallet">{{ $t("common.cancel") }}</el-button>
        <el-button size="small" type="primary" @click="handlerChangeToWallet"
          >{{ $t("common.definite") }}<span v-if="walletTime > 0">({{ walletTime }})</span></el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    // 需要的 extensions
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    Strike,
    ListItem,
    BulletList,
    OrderedList,
    Link,
    Image,
    CodeBlock,
    Blockquote,
    TodoItem,
    TodoList,
    TextAlign,
    FontSize,
    FontType,
    Fullscreen,
    TextHighlight,
    TextColor,
    FormatClear,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    History,
    TrailingNode,
    HardBreak,
    HorizontalRule,
    LineHeight,
    Indent
  } from "element-tiptap";
  export default {
    name: "SystemConfig",
    beforeRouteLeave(to, from, next) {
      if (JSON.stringify(this.copyData) === JSON.stringify(this.tableData)) {
        next();
        return;
      }
      // 这里需要elementui的支持，如果使用其他界面组件自行替换即可
      this.$confirm(this.$t("system.leaveTip"), this.$t("system.warn"), {
        confirmButtonText: this.$t("helpcenter.confirm"),
        cancelButtonText: this.$t("temperature.exportqx"),
        type: "warning"
      })
        .then(() => {
          // 正常跳转
          next();
        })
        .catch(() => {
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          window.history.go(1);
        });
    },
    data() {
      return {
        dialogToWallet: false,
        walletTime: 3,
        loading: false,
        setting: {},
        tableData: [],
        copyData: [],
        smsprice: "", //短信费用
        lookTips: {
          title: "",
          dialogVisible: false,
          content: ""
        },
        exitDialogVisible: false,
        smsDialogVisible: false,
        nowRow: {},
        // 全字典
        keywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{orderNo}",
            look: "【" + this.$t("system.orderNumber") + "】"
          },
          {
            send: "{orderPrice}",
            look: "【" + this.$t("system.orderPrice") + "】"
          },
          {
            send: "{productName}",
            look: "【" + this.$t("system.goodsName") + "】"
          },
          {
            send: "{machineName}",
            look: "【" + this.$t("system.equipmentName") + "】"
          },
          {
            send: "{lineNo}",
            look: "【" + this.$t("system.lineNo") + "】"
          },
          {
            send: "{machineNo}",
            look: "【" + this.$t("system.equipmentNo") + "】"
          },
          {
            send: "{machineAddress}",
            look: "【" + this.$t("system.machineAddress") + "】"
          },
          {
            send: "{walletBalance}",
            look: "【" + this.$t("system.walletBalance") + "】"
          },
          {
            send: "{walletEntry}",
            look: "【" + this.$t("system.walletEntry") + "】"
          }
        ],
        // 订单模块
        ddkeywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{orderNo}",
            look: "【" + this.$t("system.orderNumber") + "】"
          },
          {
            send: "{orderPrice}",
            look: "【" + this.$t("system.orderPrice") + "】"
          },
          {
            send: "{productName}",
            look: "【" + this.$t("system.goodsName") + "】"
          },
          {
            send: "{machineName}",
            look: "【" + this.$t("system.equipmentName") + "】"
          },
          {
            send: "{lineNo}",
            look: "【" + this.$t("system.lineNo") + "】"
          },
          {
            send: "{machineNo}",
            look: "【" + this.$t("system.equipmentNo") + "】"
          },
          {
            send: "{machineAddress}",
            look: "【" + this.$t("system.machineAddress") + "】"
          }
        ],
        // 订单模块
        jqkeywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{machineName}",
            look: "【" + this.$t("system.equipmentName") + "】"
          },
          {
            send: "{machineNo}",
            look: "【" + this.$t("system.equipmentNo") + "】"
          },
          {
            send: "{machineAddress}",
            look: "【" + this.$t("system.machineAddress") + "】"
          }
        ],
        // 账户字典
        zhkeywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{orderNo}",
            look: "【" + this.$t("system.orderNumber") + "】"
          },
          {
            send: "{orderPrice}",
            look: "【" + this.$t("system.orderPrice") + "】"
          },

          {
            send: "{walletBalance}",
            look: "【" + this.$t("system.walletBalance") + "】"
          }
        ],
        isPayTip: false,
        extensions: this.getExtensions(),
        range: {
          end: 0,
          endText: ""
        }
      };
    },
    mounted() {
      this.handlerGetInfo();
    },
    methods: {
      getExtensions() {
        let that = this;
        return [
          new Doc(), // 必须项
          new Text({
            length: 20
          }), // 必须项
          new Paragraph(), // 必须项
          new Heading({ level: 6 }), // 标题
          new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
          new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
          new Italic({ bubble: true }), // 斜体
          new Strike({ bubble: true }), // 删除线
          new ListItem(), // 使用列表必须项
          new BulletList({ bubble: true }), // 无序列表
          new OrderedList({ bubble: true }), // 有序列表
          new Link(), // 链接
          new Image({
            // 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
            // 自定义图片上传(默认会把图片生成base64字符串和内容存储到一起)
            // 图片的上传方法，返回一个 Promise<url>
            async uploadRequest(file) {
              // 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
              const formdata = new FormData();
              //  image是后台接口需要参数名
              formdata.append("file", file);
              //  调用接口进行上传,拿到服务器返回的图片地址
              const res = await that.$api.request(that.$url.common.upload, that.$method.post, formdata);

              if (res.code === 0) {
                return res.data;
              }
              that.$message.warning(res.msg);
              return false;
            }
          }), // 图片
          new CodeBlock({ bubble: true }), // 代码块
          new Blockquote(), // 引用
          new TodoItem(), // 任务列表必须项
          new TodoList(), // 任务列表
          new TextAlign({ bubble: true }), // 文本对齐方式
          new FontSize({ bubble: true }), // 字号
          new FontType({ bubble: true }), // 字体
          new Fullscreen(), // 全屏
          new TextHighlight({ bubble: true }), // 文本高亮
          new TextColor({ bubble: true }), // 文本颜色
          new FormatClear({ bubble: true }), // 清除格式
          new Table({ resizable: true }), // 表格
          new TableHeader(), // 表格必须项
          new TableCell(), // 表格必须项
          new TableRow(), // 表格必须项
          new History(), // 撤销
          new TrailingNode(), // 重做
          new HardBreak(), // 分割线
          new HorizontalRule(), // 行距
          new LineHeight(), // 增加缩进
          new Indent() // 减少缩进
        ];
      },
      // 点击邮件按钮的时候
      emailChangeHandler(value, index, row) {
        if (row.enabled == 1 && value == 1 && (index == 0 || index == 1 || index == 4 || index == 5)) {
          // 勾选了邮件收费且开关为开
          this.isPayTip = true;
        }
      },
      // 开关更改
      handlerLockChange(value, index, row) {
        let _self = this;
        console.log(value, index);
        if (value == 1) {
          this.$confirm(_self.$t("system.payTip"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel")
          })
            .then(() => {
              if (row.email == 1) {
                _self.isPayTip = true;
              }
            })
            .catch(() => {
              _self.tableData[index].enabled = 0;
            });
        }
      },
      // 获取有无收费项目函数
      async getHasMoney() {
        // 判断是否开启了任何付费项目
        let isOpen = false;
        this.tableData.forEach((item, index) => {
          if (index == 0 || index == 1 || index == 4 || index == 5) {
            if (item.enabled == "1" && (item.phone == "1" || item.email == "1")) {
              isOpen = true;
            }
          } else {
            if (item.enabled == "1" && item.phone == "1") {
              isOpen = true;
            }
          }
        });
        // 没收费项
        if (!isOpen) return true;
        // 判断有无零钱
        let localuserid = this.$cookies.get("uid");
        let obj = {
          uId: localuserid
        };
        let res = await this.$api.request(this.$url.myWallet.wallet, this.$method.get, obj);
        if (res.code === 0) {
          console.log(res.data.price, "当前余额price");
          if (+res.data.price > 0) {
            return true;
          }
          return false;
        } else {
          this.$message.warning(this.$t("system.cztk"));
          this.loading = false;
        }
      },
      handlerCloseWallet() {
        this.dialogToWallet = false;
        this.loading = false;
        console.log(this.loading);
      },
      handlerChangeToWallet() {
        clearInterval();
        this.$router.push("/mywallet/topup");
      },
      // 保存--提交
      async handlerSave() {
        let that = this;
        // this.loading = true;
        // let hasMoney = await this.getHasMoney();
        // if (!hasMoney) {
        //   this.dialogToWallet = true;
        //   that.walletTime = 3;
        //   let timer = setInterval(() => {
        //     if (!that.dialogToWallet) {
        //       clearInterval(timer);
        //       return;
        //     }
        //     that.walletTime = that.walletTime - 1;
        //     if (that.walletTime == 0) {
        //       clearInterval(timer);
        //       that.$router.push("/mywallet/topup");
        //     }
        //   }, 1000);
        //   return;
        // }
        // // 循环数组如果没有勾选邮件的 则isPayTip 为false
        // let templock = false;
        // that.tableData.forEach(item => {
        //   if (item.email == 1) {
        //     templock = true;
        //   }
        // });
        // if (!templock) {
        //   //如果没有开的 那就关上
        //   that.isPayTip = false;
        // }
        // if (that.isPayTip) {
        //   // 判断邮件收费
        //   that
        //     .$confirm(that.$t("system.payTip2"), {
        //       confirmButtonText: that.$t("common.definite"),
        //       cancelButtonText: that.$t("common.cancel")
        //     })
        //     .then(_ => {
        //       that.save2();
        //     })
        //     .catch(_ => {
        //       return;
        //     });
        // } else {
        //   that.save2();
        // }
        that.save2();
      },
      // save2
      save2() {
        let that = this;
        that.loading = true;
        let value = {};
        that.tableData.forEach(item => {
          value[item.wname] = {
            email: item.email,
            emailText: item.emailText,
            emailTitle: item.emailTitle,
            enabled: item.enabled,
            phone: item.phone,
            phoneText: item.phoneText,
            phoneTitle: item.phoneTitle,
            repair: item.repair,
            self: item.self
          };
        });
        for (let i in value) {
          value[i].emailText = that.filterKey("send", value[i].emailText);
          value[i].phoneText = that.filterKey("send", value[i].phoneText);
          console.log('value',value[i].phoneText);
        }
        let url = that.$url.Promote.save;
        let method = that.$method.post;
        that.$api
          .request(url, method, {
            type: "NOTICE",
            content: JSON.stringify(value)
          })
          .then(res => {
            that.loading = false;
            if (res.code === 0) {
              that.$message.success(res.msg);
              // 保存成功后重新备份
              that.copyData = JSON.parse(JSON.stringify(that.tableData));
              that.isPayTip = false;
            } else {
              that.$message.warning(res.msg);
            }
          });
      },
      // 重置
      reset() {
        this.tableData = JSON.parse(JSON.stringify(this.copyData));
        this.$message.success(this.$t("system.resetSucess"));
      },
      // 合并单元格
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return {
              rowspan: 1,
              colspan: 1
            };
          } else if (rowIndex === 1) {
            return {
              rowspan: 3,
              colspan: 1
            };
          } else if (rowIndex === 4) {
            return {
              rowspan: 10,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      // 插入
      handlerBlur({ editor }) {
        // console.log(window.getSelection().getRangeAt(0));
        // console.log(editor);
        let wz = window.getSelection().getRangeAt(0);
        // let start = wz.startOffset;
        this.range.end = wz.endOffset;
        this.range.endText = wz.endContainer.nodeValue;
        // 第一步查找endContent的index  然后在index+end处插入文本  若文本endContent为null则为开头
        // console.log(start, end, endContent);
      },
      handlerAddToPoint(word) {
        if (this.range.endText === null) {
          this.nowRow.emailText = word + this.nowRow.emailText;
          console.log(1);
          return;
        }
        let startIndex = this.nowRow.emailText.indexOf(this.range.endText) + this.range.end; //文本开始索引
        let textarr = this.nowRow.emailText.split("");
        textarr.splice(startIndex, 0, word);
        this.nowRow.emailText = textarr.join("");
      },
      // 添加变量到短信内容
      handlerAddToSmsPoint(word) {
        const textarea = document.querySelector('.el-textarea__inner');
        if (textarea) {
          const cursorPos = textarea.selectionStart;
          const textBefore = this.nowRow.phoneText.substring(0, cursorPos);
          const textAfter = this.nowRow.phoneText.substring(cursorPos);
          this.nowRow.phoneText = textBefore + word + textAfter;
          // 设置光标位置到插入文本之后
          this.$nextTick(() => {
            textarea.focus();
            textarea.setSelectionRange(cursorPos + word.length, cursorPos + word.length);
          });
        } else {
          // 如果没有获取到光标位置，就添加到末尾
          this.nowRow.phoneText = this.nowRow.phoneText + word;
        }
      },
      
      // 添加变量到邮件内容
      handlerAddToEmailPoint(word) {
        const textarea = document.querySelector('.el-textarea__inner');
        if (textarea) {
          const cursorPos = textarea.selectionStart;
          const textBefore = this.nowRow.emailText.substring(0, cursorPos);
          const textAfter = this.nowRow.emailText.substring(cursorPos);
          this.nowRow.emailText = textBefore + word + textAfter;
          // 设置光标位置到插入文本之后
          this.$nextTick(() => {
            textarea.focus();
            textarea.setSelectionRange(cursorPos + word.length, cursorPos + word.length);
          });
        } else {
          // 如果没有获取到光标位置，就添加到末尾
          this.nowRow.emailText = this.nowRow.emailText + word;
        }
      },
      // launch
      handlerGetInfo() {
        let _self = this;
        _self.loading = true;
        let url = _self.$url.Promote.get;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, {
            type: "NOTICE"
          })
          .then(res => {
            if (res.code === 0) {
              _self.loading = false;
              _self.setting = res.data;
              // 循环进入数组操作
              _self.tableData = [];
              for (let i in res.data) {
                // 替换文本
                res.data[i].emailText = _self.filterKey("look", res.data[i].emailText);
                res.data[i].phoneText = _self.filterKey("look", res.data[i].phoneText);
                // 初始化phoneTitle如果不存在
                if (!res.data[i].phoneTitle) {
                  res.data[i].phoneTitle = '';
                }
                _self.tableData.push({
                  ...res.data[i],
                  wname: i
                });
              }
              // 添加模块名称 1订单 2机器 2账户
              _self.tableData[0].type = 1;
              _self.tableData[1].type = 2;
              _self.tableData[2].type = 2;
              _self.tableData[3].type = 2;
              _self.tableData[4].type = 2;
              _self.tableData[5].type = 2;
              _self.tableData[6].type = 2;
              _self.tableData[7].type = 2;
              _self.tableData[8].type = 2;
              _self.tableData[9].type = 2;
              _self.tableData[10].type = 2;
              _self.tableData[11].type = 3;
              _self.tableData[12].type = 3;
              _self.tableData[13].type = 3;
              //  颠倒位置
              _self.insertLastThree(_self.tableData);
              // 复制一份
              _self.copyData = JSON.parse(JSON.stringify(_self.tableData));
            }
          })
          .catch(err => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
        // 获取短信费用
        let urls = _self.$url.Promote.getDictValue;
        let methods = _self.$method.get;
        _self.$api
          .request(urls, methods, {
            type: "service_type_amount",
            label: "WALLET_SMS"
          })
          .then(res => {
            if (res.code === 0) {
              try {
                this.smsprice = parseFloat(res.data[0].value);
              } catch (error) {
                console.log(error);
              }
            }
          })
          .catch(err => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      // 颠倒位置函数
      insertLastThree(arr) {
        // 首先确保数组长度大于或等于3
        if (arr.length >= 3) {
          // 将数组的最后三项插入到第2、3、4位
          arr.splice(1, 0, arr.pop(), arr.pop(), arr.pop());
        } else {
          // 如果数组长度不足3个元素，无法进行插入操作
          console.log("数据异常");
        }
        return arr;
      },
      // 编辑短信
      handlerExitOne(row) {
        this.nowRow = row;
        this.exitDialogVisible = true;
      },
      // 编辑短信内容
      handlerEditSms(row) {
        // 创建一个副本，将显示格式转换为编辑格式
        this.nowRow = { 
          ...row,
          // 保持显示格式用于编辑
          phoneText: row.phoneText,
          phoneTitle: row.phoneTitle || ''
        };
        this.smsDialogVisible = true;
      },
      // 保存邮件内容
      saveEmailContent() {
        // 更新表格中的数据
        const index = this.tableData.findIndex(item => item.wname === this.nowRow.wname);
        if (index !== -1) {
          // 更新邮件标题和内容
          this.$set(this.tableData[index], 'emailTitle', this.nowRow.emailTitle);
          this.$set(this.tableData[index], 'emailText', this.nowRow.emailText);
        }
        
        // 立即保存到后端 - 只保存当前编辑的行
        this.saveSingleEmailToBackend(this.nowRow.wname, this.nowRow.emailTitle, this.nowRow.emailText);
        
        this.exitDialogVisible = false;
      },
      // 保存短信内容
      saveSmsContent() {
        // 更新表格中的数据
        const index = this.tableData.findIndex(item => item.wname === this.nowRow.wname);
        if (index !== -1) {
          // 直接更新显示格式的内容
          this.$set(this.tableData[index], 'phoneText', this.nowRow.phoneText);
          this.$set(this.tableData[index], 'phoneTitle', this.nowRow.phoneTitle);
        }
        
        // 立即保存到后端 - 只保存当前编辑的行
        this.saveSingleSmsToBackend(this.nowRow.wname, this.nowRow.phoneTitle, this.nowRow.phoneText);
        
        this.smsDialogVisible = false;
      },
      saveSingleEmailToBackend(wname, emailTitle, emailText) {
        let that = this;
        that.loading = true;
        
        // 转换显示格式为后端格式
        let convertedEmailText = that.filterKey("send", emailText);
        
        // 获取完整的当前配置
        let value = {};
        that.tableData.forEach(item => {
          value[item.wname] = {
            email: item.email,
            emailText: item.wname === wname ? convertedEmailText : that.filterKey("send", item.emailText),
            emailTitle: item.wname === wname ? emailTitle : item.emailTitle,
            enabled: item.enabled,
            phone: item.phone,
            phoneText: that.filterKey("send", item.phoneText),
            repair: item.repair,
            self: item.self
          };
        });
       
        let url = that.$url.Promote.save;
        let method = that.$method.post;
        that.$api
          .request(url, method, {
            type: "NOTICE",
            content: JSON.stringify(value)
          })
          .then(res => {
            console.log('value',res);
            that.loading = false;
            if (res.code === 0) {
              that.$message.success(res.msg);
              // 保存成功后重新备份
              that.copyData = JSON.parse(JSON.stringify(that.tableData));
            } else {
              that.$message.warning(res.msg);
            }
          })
          .catch(err => {
            that.loading = false;
            that.$notify({
              title: that.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      
      // 保存单个短信到后端
      saveSingleSmsToBackend(wname, phoneTitle, phoneText) {
        let that = this;
        that.loading = true;
        
        // 转换显示格式为后端格式
        let convertedPhoneText = that.filterKey("send", phoneText);
        
        // 获取完整的当前配置
        let value = {};
        that.tableData.forEach(item => {
          value[item.wname] = {
            email: item.email,
            emailText: item.emailText,
            emailTitle: item.emailTitle,
            enabled: item.enabled,
            phone: item.phone,
            phoneText: item.wname === wname ? convertedPhoneText : that.filterKey("send", item.phoneText),
            phoneTitle: item.wname === wname ? phoneTitle : item.phoneTitle,
            repair: item.repair,
            self: item.self
          };
        });
        
        // 转换其他内容的显示格式为后端格式
        for (let i in value) {
          if (i !== wname) {
            value[i].emailText = that.filterKey("send", that.tableData.find(row => row.wname === i).emailText);
          } else {
            value[i].emailText = that.filterKey("send", that.tableData.find(row => row.wname === i).emailText);
          }
        }
        console.log('value: ',value);
        let url = that.$url.Promote.save;
        let method = that.$method.post;
        that.$api
          .request(url, method, {
            type: "NOTICE",
            content: JSON.stringify(value)
          })
          .then(res => {
            that.loading = false;
            if (res.code === 0) {
              that.$message.success(res.msg);
              // 保存成功后重新备份
              that.copyData = JSON.parse(JSON.stringify(that.tableData));
            } else {
              that.$message.warning(res.msg);
            }
          })
          .catch(err => {
            that.loading = false;
            that.$notify({
              title: that.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      
      // 保存短信到后端
      saveSmsToBackend() {
        let that = this;
        that.loading = true;
        let value = {};
        that.tableData.forEach(item => {
          value[item.wname] = {
            email: item.email,
            emailText: item.emailText,
            emailTitle: item.emailTitle,
            enabled: item.enabled,
            phone: item.phone,
            phoneText: item.phoneText,
            phoneTitle: item.phoneTitle,
            repair: item.repair,
            self: item.self
          };
        });
        
        // 转换显示格式为后端格式
        console.log("Before transformation:", JSON.parse(JSON.stringify(value)));
        for (let i in value) {
          value[i].emailText = that.filterKey("send", value[i].emailText);
          value[i].phoneText = that.filterKey("send", value[i].phoneText);
        }
        console.log("After transformation:", JSON.parse(JSON.stringify(value)));
        
        let url = that.$url.Promote.save;
        let method = that.$method.post;
        that.$api
          .request(url, method, {
            type: "NOTICE",
            content: JSON.stringify(value)
          })
          .then(res => {
            console.log("Save response:", res);
            that.loading = false;
            if (res.code === 0) {
              that.$message.success(res.msg);
              // 保存成功后重新备份
              that.copyData = JSON.parse(JSON.stringify(that.tableData));
            } else {
              that.$message.warning(res.msg);
            }
          })
          .catch(err => {
            console.error("Save error:", err);
            that.loading = false;
            that.$notify({
              title: that.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      // 查看tips
      handlerLookTips(n, content) {
        n == 1 ? (this.lookTips.title = "SMS") : (this.lookTips.title = "MAIL");
        content = this.filterKey("look", content);
        this.lookTips.content = content;
        this.lookTips.dialogVisible = true;
      },
      filterKey(methods, str) {
        let unMethods = "";
        if (methods == "look") {
          unMethods = "send";
        } else {
          unMethods = "look";
        }
        
        this.keywords.forEach(item => {
          str = str.replace(new RegExp(this.escapeRegExp(item[unMethods]), 'g'), item[methods]);
        });
        return str;
      },
      
      // Helper function to escape special regex characters
      escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .add-product {
    ::v-deep .el-dialog__body {
      height: auto;
      padding: 10px 30px;
    }
    ::v-deep .el-form-item__content {
      line-height: 40px;
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .ca {
    color: #aaa;
    ::v-deep .el-form-item__label {
      color: #aaa;
    }
  }
</style>
